import React from 'react';
import samLogo from '../../assets/raya-logo2.PNG';
import './footer.css';

const Footer = () => (
    <div className="sam__footer section__padding" id='footer'>
        <div className="sam__footer-heading">
            <h1 className="gradient__text">ارتباط باما</h1>
        </div>

        {/* <div className="sam__footer-btn">
            <p>Request Early Access</p>
        </div> */}

        <div className="sam__footer-links">
            <div className="sam__footer-links_logo">
                <img src={samLogo} alt="samTech_logo" />
            </div>
            <div className="sam__footer-links_div">
                <h4>راه ارتباطی با ما</h4>
                <p>:شماره جهت تماس</p>
                <p><a href='tel:+989024368617'>+98-902 436 8617</a></p>
                <p>:واتس اپ و تلگرام</p>
                <p>+98-921 020 1261</p>
                <p>:اینستاگرام</p>
                <p><a href='https://instagram.com/raya._.academy'>raya._.academy</a></p>
            </div>
            <div className="sam__footer-links_div">
                <h4><a href='#home'>خانه</a></h4>
                <p><a href='#wsam'>درباره ما</a></p>
                <p><a href='#features'>انواع خدمات ما</a></p>
                <p><a href='#possibility'>روش کار ما</a></p>
                <p><a href='#blog'>نمونه کار ما</a></p>

            </div>

        </div>

        <div className="sam__footer-copyright">
            <p>2022 | Ⓒ تمامی حقوق این سایت برای شرکت توسعه فناوران رایا می باشد</p>
        </div>
    </div>
);

export default Footer;
